import React, { useState } from 'react'
import PageBody from '../../../components/pagebody/PageBody'
import Button from '../../../components/button/Button'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey, setUploadedFile } from './CheckStatusSlice'
import { checkStatus, uploadFile } from './CheckStatusSaga'
import styles from './CheckStatus.styles'
import Loadable from '../../../components/loadable/Loadable'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import HorizontalSeparator from '../../../components/separator/horizontalSeparator/HorizontalSeparator'
import Label from '../../../components/label/Label'
import TextInput from '../../../components/input/textinput/TextInput'
import { LABEL_WEIGHT } from '../../../components/label/constants'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks'
import { PAGE_STATE_MESSAGE_MAP } from '../../constants/constants'

export default function CheckStatus() {

    useGarbageCollector(componentKey);
    const { loadingState, status } = useSelector((state) => state[componentKey]);
    const [referenceNum, setReferenceNum] = useState('');
    const dispatch = useDispatch();

    const handleCheckStatus = () => {
        dispatch(checkStatus({refNo: referenceNum}))
    }

    return (
            <PageBody>
                <Heading type={HEADING.H1}>Check Status</Heading>
                <div style={styles.mainContainer}>
                    <div>
                        <p>Check your Tax1099 e-filing status here. Enter your reference number and click Check Status. The reference number can be found on the Filing History page.</p>
                        <HorizontalSeparator />
                    </div>
                    <div style={styles.inputContainer}>
                        <Label customStyles={styles.whiteSpacePre}>* Enter Your Reference Number here</Label>
                        <TextInput 
                            value={referenceNum}
                            onChangeCb={(e) => setReferenceNum(e.target.value)}
                        />
                        <Button onClickCb={ handleCheckStatus }>Check Status</Button>
                    </div>
                    <Loadable currentState={loadingState.state} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
                        <Label weight={LABEL_WEIGHT[600]} customStyles={styles.statusLabel}>{status}</Label>
                    </Loadable>
                    <div>
                        <p><span style={styles.fontWeight700}>Status Key:</span></p>
                        <p><span style={styles.fontWeight700}>Pending</span> - Forms are waiting to be sent to the IRS</p>
                        <p><span style={styles.fontWeight700}>Processing</span> - The IRS is processing your file. You should receive notice of the Acceptance or Rejection soon.</p>
                        <p><span style={styles.fontWeight700}>Accepted</span> - The IRS accepted the delivery of your e-file.</p>
                        <p><span style={styles.fontWeight700}>Rejected</span> - Forms have been rejected by the IRS. Changes can be made and re-submitted for no additional charge.</p>
                    </div>
                </div>
            </PageBody>
    )
}